<template>
  <div class="bg">
    <div class="top">
      <div class="text">
        <div class="title">
          Consumer
        </div>
        <div class="value">
          Given the fast-paced economic development of many Asian markets, Holden provides you consumer insight for your product development, marketing efficiency, consumer segmentation, and experience management.

        </div>
        <div><button @click="contact">REQUEST A BID</button></div>
      </div>
    </div>

    <!-- product -->
    <div class="product d-none d-sm-block">
      <div class="text">
        <div class="title">
          <div class="top1">Concept Testing & Product Innovation</div>
          <div class="text1">Holden's product concept test is a powerful tool that derives likely consumption decisions based on purchasing/usage scenarios presented to real consumers. Holden tests both emotional and objective contributors to the decision-making process to understana the real market situation. Based on these results, combined with industry experience,Holden provides professional advice on the best concepts for the Chinese and various Asian markets.</div>
        </div>
        <div class="img"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/industryConsumer/consumer1.jpg" alt="">
          <div class="color"></div>
        </div>
      </div>
      <div class="value">
        <div>&nbsp</div>
        Holden's online platform and effective operational execution ensures that concept tests can be done quickly and effectivekly.The final goal of product concept testing is to understand the relative acceptance of particular product's inovation.Before arriving at this goal, we first, test the product concept/innovation, identifying any problems with this concept. We then focus on that problem to to understand it nature.After taking these steps, we can understand how to tweak the innovation/concept to improve consumer acceptance.
      </div>
    </div>

    <!-- 手机端-->
    <div class="productmd d-block d-sm-none">
      <div class="text">
        <div class="title">
          Concept Testing & Product Innovation
        </div>
        <div class="img"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/industryConsumer/consumer1.jpg" alt="">
          <div class="color"></div>

        </div>
      </div>
      <div class="value">
        Holden's product concept test is a powerful tool that derives likely consumption decisions based on purchasing/usage scenarios presented to real consumers. Holden tests both emotional and objective contributors to the decision-making process to understana the real market situation. Based on these results, combined with industry experience,Holden provides professional advice on the best concepts for the Chinese and various Asian markets.
        <div>&nbsp</div>
        Holden's online platform and effective operational execution ensures that concept tests can be done quickly and effectivekly.The final goal of product concept testing is to understand the relative acceptance of particular product's inovation.Before arriving at this goal, we first, test the product concept/innovation, identifying any problems with this concept. We then focus on that problem to to understand it nature.After taking these steps, we can understand how to tweak the innovation/concept to improve consumer acceptance.

      </div>
    </div>

    <!-- Segmentation -->
    <div class="Segmentation">
      <div class="text">
        <div class="title">
          Segmentation and Usage & Attitude
        </div>
        <div class="value">
          In the increasing competitive and fast-paced market, enterprises need to segment the market, so they can better identify consumer groups and determine key targeted market segments.
          <div>&nbsp</div>
          Holden can segment consumers based on demographics, attitudes, behaviors, consumption abilities, etc. In this way, Holden successfully takes the first step to more precisely segment the market at the most basic granular level possible.
        </div>
      </div>
      <div class="img"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/industryConsumer/consumer2.jpg" alt="">
        <div class="color"></div>
      </div>
    </div>

    <!-- Marketing -->
    <div class="Marketing">
      <div class="img"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/industryConsumer/consumer3.jpg" alt="">
        <div class="color"></div>
      </div>
      <div class="text">
        <div class="title">
          Marketing & Communication
        </div>
        <div class="value">
          Using online consumer surveys, we perform quick nationwide "flash" checks on the market, to understand a range of market characteristics. This typically includes anything from market size, consumer market structure, product penetration,
          distribution channels, brand/product life cycle, brand strengths and weaknesses, brand awareness, purchase level and intent, as well as the inter- relationship among all these factors.
        </div>
      </div>
    </div>

    <!-- product -->
    <div class="Management">
      <div class="text">
        <div class="title">
          Customer Experience Management
        </div>
        <div class="value">
          Holden offers proprietary CEM platform to help our client in managing customer experience throughout the whole consumer journey, covering every Moment of Truth (MOT) touch point. Using alert system, client can receive real time results and make prompt improvement actions.
        </div>
      </div>
      <div class="img"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/industryConsumer/consumer4.jpg">
        <div class="color"></div>
      </div>
    </div>

    <div class="banner">
      <el-carousel>
        <el-carousel-item>
          <div class="text">
            <div class="title">Consumer U&A study</div>
            <div class="value">Over <span style="color:#2cb1e9">213</span> consumer U&A study projects , delivering <span style="color:#2cb1e9">105032</span> completes for our clients.</div>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <div class="text">
            <div class="title">Potential user needs research</div>
            <div class="value">Over <span style="color:#2cb1e9">106</span> potential user needs research projects , delivering <span style="color:#2cb1e9">55306</span> completes for our clients.</div>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <div class="text">
            <div class="title">Consumer profiling</div>
            <div class="value">Over <span style="color:#2cb1e9">276</span> consumer profiling projects , delivering <span style="color:#2cb1e9">72167</span> completes for our clients.</div>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <div class="text">
            <div class="title">New product concept/prototype testing</div>
            <div class="value">Over <span style="color:#2cb1e9">276</span> new product concept/prototype testing projects , delivering <span style="color:#2cb1e9">104287</span> completes for our clients.</div>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <div class="text">
            <div class="title">Product packaging/price testing</div>
            <div class="value">Over <span style="color:#2cb1e9">159</span> product packaging/price testing projects , delivering <span style="color:#2cb1e9">49872</span> completes for our clients.</div>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <div class="text">
            <div class="title">Advertising film pre-testing</div>
            <div class="value">Over <span style="color:#2cb1e9">59</span> advertising film pre-testing projects , delivering <span style="color:#2cb1e9">12921</span> completes for our clients.</div>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <div class="text">
            <div class="title">Advertising effectiveness evaluation and monitoring</div>
            <div class="value">Over <span style="color:#2cb1e9">143</span> advertising effectiveness evaluation and monitoring projects , delivering <span style="color:#2cb1e9">52069</span> completes for our clients.</div>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <div class="text">
            <div class="title">Consumer satisfaction/loyalty studies</div>
            <div class="value">Over <span style="color:#2cb1e9">98</span> Consumer satisfaction/loyalty studies projects , delivering <span style="color:#2cb1e9">57722</span> completes for our clients.</div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>

    <!-- 底部轮播图 -->
    <div class="consumer">
      <div class="title"> Holden has accumulated rich experience in verticals such as packaged goods, home appliances, OTC healthcare etc. Out clients include global/regional top 500 companies.
      </div>
      <vue-seamless-scroll :data="List" :class-option="optionLeft" class="seamless-warp2">
        <ul class="item">
          <li v-for="(item,index) in List" :key="index">
            <span><img :src="item.src" :data-index="index"></span>
          </li>

        </ul>
      </vue-seamless-scroll>
    </div>
  </div>
</template>

<script>
import vueSeamlessScroll from "vue-seamless-scroll";
import { advertisementFlow } from "@/api/api";
export default {
  data() {
    return {
      List: [
        { src: "https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/industryConsumer/banner1.png" },
        { src: "https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/industryConsumer/banner2.png" },
        { src: "https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/industryConsumer/banner3.png" },
        { src: "https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/industryConsumer/banner4.png" },
        { src: "https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/industryConsumer/banner5.png" },
        { src: "https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/industryConsumer/banner6.png" },
        { src: "https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/industryConsumer/banner7.png" },
        { src: "https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/industryConsumer/banner8.png" },
        { src: "https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/industryConsumer/banner9.png" },
        { src: "https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/industryConsumer/banner10.png" },
        { src: "https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/industryConsumer/banner11.png" },
        { src: "https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/industryConsumer/banner12.png" },
        { src: "https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/industryConsumer/banner13.png" },
        { src: "https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/industryConsumer/banner14.png" },
        { src: "https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/industryConsumer/banner15.png" },
        { src: "https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/industryConsumer/banner16.png" },
        { src: "https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/industryConsumer/banner17.png" },
        { src: "https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/industryConsumer/banner18.png" },
        { src: "https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/industryConsumer/banner19.png" },
        { src: "https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/industryConsumer/banner20.png" },
        { src: "https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/industryConsumer/banner21.png" },
        { src: "https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/industryConsumer/banner22.png" }
      ]
    };
  },
  created() {
    this.loading();
    this.advertisementFlow(); // 在组件创建时加载Google代码
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtag/js?id=AW-11335422054";
    document.head.appendChild(script);
    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        dataLayer.push(arguments);
      }
      gtag("js", new Date());
      gtag("config", "AW-11335422054");
    };
    this.webinercookies();
  },
  components: { vueSeamlessScroll },
  computed: {
    optionLeft() {
      return {
        direction: 2,
        limitMoveNum: 1,
        step: 0.5,
        hoverStop: false
      };
    }
  },
  methods: {
    webinercookies() {
      // 如果没有记录cookie
      if (!localStorage.getItem("webinersource")) {
        // 就不重新赋值
        let webinersource = this.$route.query.source;

        if (webinersource == undefined) {
          localStorage.setItem("webinersource", "www");
        } else {
          localStorage.setItem("webinersource", webinersource);
        }
        // console.log(1);
      } else {
        // 如果没有cookie就设置cookie
      }
    },
    advertisementFlow() {
      // 如果没有source
      if (this.$route.query.source == undefined) {
        // console.log(1);
        // 就把source拼接
        advertisementFlow({
          path: "consumer",
          source: "",
          information: "Solutions_consumer"
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
          }
        });
        // 如果有source
      } else {
        advertisementFlow({
          path: "consumer",
          source: this.$route.query.source,
          information: "Solutions_consumer"
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
          }
        });
      }
    },
    contact() {
      let routeData = this.$router.resolve({ path: "/contact?source=bid" });
      window.open(routeData.href, "_blank");
    },
    loading() {
      this.$loading({
        lock: true,
        background: "rgba(255, 255, 255,1)"
      });
      setTimeout(() => {
        this.$loading().close();
      }, 700);
    }
  }
};
</script>

<style lang="scss" scoped>
.bg {
  background-image: url("https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/industryConsumer/consumer.jpg");
  background-size: cover;
  background-attachment: fixed;
}
.top {
  padding: 155px 200px;
  background-image: url("https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/industryConsumer/consumerbg.png");
  background-size: cover;
  // height: 600px;
  .text {
    width: 60%;
    .title {
      width: 70%;
      font-size: 50px;
      font-weight: 700;
      margin-bottom: 25px;
      color: #fff;
    }
    .value {
      font-size: 20px;
      color: #fff;
    }
    button {
      border: none;
      background-color: #2cb1e9;
      color: #fff;
      font-size: 20px;
      border-radius: 10px;
      margin-top: 20px;
      padding: 10px;
    }
  }
}
.Management {
  background-color: #fff;
  display: flex;
  padding: 50px 120px;
  height: 730px;
  position: relative;

  .text {
    position: absolute;
    left: 240px;
    top: 180px;
    // width: 55%;
    // color: #fff;
    padding: 50px 50px 50px 400px;
    background-color: #d0e3ea;
    z-index: 0;

    .title {
      font-weight: 700;
      font-size: 40px;
      color: #2cb1e9;
      text-shadow: 1px 1px #000;
    }
    .value {
      font-size: 23px;
      padding-top: 50px;
    }
  }
  .img {
    width: 35%;
    position: absolute;
    top: 100px;
    img {
      width: 95%;
      z-index: 2;
    }
  }
}
.Segmentation {
  background-color: #fff;
  display: flex;
  flex-wrap: wrap;
  padding: 50px 120px;
  .text {
    width: 45%;
    // color: #fff;
    padding: 50px;
    .title {
      font-weight: 700;
      font-size: 40px;
      color: #2cb1e9;
      text-shadow: 1px 1px #000;
    }
    .value {
      padding: 50px 0;
      font-size: 23px;
    }
  }
  .img {
    width: 55%;
    position: relative;
    img {
      width: 85%;
      position: absolute;
      right: 0;
      z-index: 2;
    }
    .color {
      width: 600px;
      height: 420px;
      background-color: #d0e3ea;
      position: absolute;
      left: 0px;
      top: 120px;
    }
  }
}
.Marketing {
  background-color: #fff;
  display: flex;
  padding: 0px 120px;
  padding-bottom: 50px;
  // height: 1000px;

  .text {
    width: 60%;
    padding: 50px;
    .title {
      font-weight: 700;
      font-size: 40px;
      color: #2cb1e9;
      text-shadow: 1px 1px #000;
    }
    .value {
      font-size: 23px;
      margin-top: 50px;
    }
    .advantage {
      .title {
        font-size: 30px;
        color: #000;
      }
      .value {
        margin-top: 0;
      }
    }
  }
  .img {
    width: 40%;
    position: relative;
    img {
      width: 90%;
      position: absolute;
      z-index: 2;
    }
    .color {
      width: 350px;
      height: 350px;
      background-color: #d0e3ea;
      position: absolute;
      top: 150px;
      left: 150px;
    }
  }
}
.productmd {
  background-color: #fff;
  display: flex;
  padding: 100px;
  flex-direction: column;
  height: 5300px;
  .text {
    // width: 45%;
    display: flex;
    position: relative;
    // padding: 50px;
    .title {
      // position: absolute;
      bottom: 0;
      width: 45%;
      // height: 45%;
      padding: 50px;
      font-size: 80px;
      font-weight: 700;
      color: #2cb1e9;
      text-shadow: 1px 1px #000;
      background-color: #d0e3ea;
    }
    .img {
      width: 55%;
      // text-align: right;
      // position: absolute;
      // right: 0;
      // top: 0;
      img {
        width: 100%;
        height: 100%;
        float: right;
      }
    }
  }
  .value {
    width: 90%;
    font-size: 70px;
    background-color: #d0e3ea;
    padding: 50px;
  }
}
.product {
  background-color: #fff;
  display: flex;
  padding: 100px 120px;
  flex-direction: column;
  height: 1200px;
  .text {
    // width: 45%;
    display: flex;
    position: relative;
    // padding: 50px;
    .title {
      .top1 {
        background-color: #d0e3ea;
        font-size: 40px;
        font-weight: 700;
        color: #2cb1e9;
        text-shadow: 1px 1px #000;
        padding-bottom: 50px;
      }
      // position: absolute;
      bottom: 0;
      width: 45%;
      // height: 45%;
      padding: 50px;
      padding-bottom: 0;

      background-color: #d0e3ea;
      .text1 {
        font-size: 23px;
        // color: #000;
        // font-weight: 400;
      }
    }
    .img {
      width: 55%;
      // text-align: right;
      // position: absolute;
      // right: 0;
      // top: 0;
      img {
        width: 100%;
        float: right;
      }
    }
  }
  .value {
    width: 90%;
    font-size: 23px;
    background-color: #d0e3ea;
    padding: 50px;
    padding-top: 0;
  }
}
.banner {
  background-color: rgba(255, 255, 255, 0.5);
  .text {
    padding: 80px 150px;
    .title {
      font-size: 40px;
      color: #2cb1e9;
      font-weight: 700;
    }
    .value {
      font-size: 23px;
      font-weight: 700;
      padding: 50px;
    }
  }
}
.seamless-warp2 {
  background-color: #fff;
  padding: 50px 0;
  margin: 0 auto;
  overflow: hidden;
  height: 270px;
  //   width: 1036px;
  .item {
    padding: 20px;
    // width: 960px;
    display: flex;
    justify-content: space-between;
    li {
      border: 1px solid rgb(196, 185, 185);
      width: 162.2px;
      padding: 10px 20px;
      //   height: 74px;
      //   display: inline-block;
      display: flex;
      align-items: center;
      //   float: left;
      margin-right: 100px;
      //   line-height: 125px;
      text-align: center;
      img {
        width: 100%;
      }
    }
  }
}
.consumer {
  background-color: #fff;
  padding-top: 80px;
  font-size: 30px;
  font-weight: 700;
  text-align: center;
  color: #2cb1e9;
  .title {
    padding: 0 120px;
  }
}
@media screen and (max-width: 576px) {
  .consumer {
    font-size: 50px;
  }
  .top {
    padding: 90px 100px;
    .text {
      width: 100%;
      .title {
        width: 80%;
        font-size: 110px;
      }
      .value {
        font-size: 70px;
      }
      button {
        font-size: 70px;
        padding: 10px 20px;
      }
    }
  }
  .Segmentation {
    position: relative;
    padding-top: 1300px;
    .text {
      display: block;
      width: 100%;
      .title {
        font-size: 80px;
      }
      .value {
        font-size: 70px;
      }
    }
    .img {
      top: 100px;
      width: 80%;
      position: absolute;
      .color {
        height: 1000px;
      }
    }
  }
  .Marketing {
    position: relative;
    display: block;
    padding-top: 1500px;
    .text {
      width: 100%;
      .title {
        font-size: 80px;
      }
      .value {
        font-size: 70px;
      }
    }
    .img {
      position: absolute;

      top: 300px;
      width: 80%;
      .color {
        width: 700px;
        height: 700px;
        top: 500px;
        left: 500px;
      }
    }
  }
  .Management {
    height: 2800px;
    display: block;
    .img {
      width: 90%;
    }
    .text {
      top: 900px;
      left: 0;
      .title {
        font-size: 80px;
      }
      .value {
        font-size: 70px;
      }
    }
  }

  .banner {
    .text {
      padding-top: 120px;
      .title {
        font-size: 80px;
      }
      .value {
        font-size: 60px;
      }
    }
  }
}
</style>
<style lang="scss">
@media screen and (max-width: 576px) {
  .el-carousel {
    // height: 800px;
    .el-carousel__container {
      height: 1000px !important;
      .el-carousel__arrow {
        width: 100px;
        height: 100px;
        i {
          font-size: 40px;
        }
      }
    }
  }
}
</style>